import { useStore } from "../store";
import { useIsGlobalAdmin } from "./useIsGlobalAdmin";

const PAID = new Set(["Starter", "Growth", "Business", "Enterprise"]);

/**
 * Content, plans, research and media. Matches BrandKarmaAuthPolicies.PaidPlan:
 * any non-Free plan, plus GlobalAdmin. Starter stays so grandfathered tenants
 * still see the feature.
 */
export function useCanUseContent() {
  const isGlobalAdmin = useIsGlobalAdmin();
  const plan = useStore((s) => s.tenantProfile?.plan);
  return isGlobalAdmin || PAID.has(plan);
}
